// All data fetching for this page lives in src/helpers/apiLogs.js, so this
// route carries no api1/onLoad action of its own - RouteComponent still
// expects an `api` object, it is just empty.
export default {};
